import { getAppDomain, AppDomain } from '../../router/domainRouter';

export const isServer = typeof window === 'undefined';

export interface RuntimeConfig {
  isApp: boolean;
  isManager: boolean;
  /** Domínio de cadastro (abertura de conta WasteBank) */
  isCadastro: boolean;
  appName: string;
  appleTouchIcon: string;
  themeColor: {
    light: string;
    dark: string;
  };
}

export const getRuntimeConfig = (): RuntimeConfig => {
  if (isServer) {
    return {
      isApp: true,
      isManager: false,
      isCadastro: false,
      appName: 'WasteMap App',
      appleTouchIcon: '/logo_light.png',
      themeColor: {
        light: '#2563eb', // Blue
        dark: '#0f172a',  // Slate 900
      },
    };
  }

  const domain = getAppDomain();
  const isManager = domain === AppDomain.MANAGER;
  const isCadastro = domain === AppDomain.REGISTRATION;

  return {
    isApp: !isManager,
    isManager,
    isCadastro,
    appName: isManager ? 'WasteMap Manager' : isCadastro ? 'WasteBank - Abertura de Conta Digital' : 'WasteMap App',
    // We can define custom items or themes for branding if needed
    appleTouchIcon: isManager ? '/logo_light.png' : '/logo_light.png',
    themeColor: {
      // Cadastro: azul-marinho da marca WasteBank
      light: isCadastro ? '#1b2340' : isManager ? '#0f172a' : '#2563eb', // Dark theme or primary blue
      dark: isCadastro ? '#1b2340' : '#0f172a',
    },
  };
};

export const RUNTIME = getRuntimeConfig();
